import { render, staticRenderFns } from "./EditarAtalhos.vue?vue&type=template&id=0e8de6ba&scoped=true&lang=pug"
import script from "./EditarAtalhos.vue?vue&type=script&lang=js"
export * from "./EditarAtalhos.vue?vue&type=script&lang=js"
import style0 from "./EditarAtalhos.vue?vue&type=style&index=0&id=0e8de6ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8de6ba",
  null
  
)

export default component.exports